// src/store/useNewsStore.ts
import { create } from "zustand";
import { getNewsApi, getNewsDetailApi } from "../api/newsApi";
import { NewsItem } from "../types/news";

interface NewsState {
  items: NewsItem[];
  detail: NewsItem | null;
  currentPage: number;
  totalPages: number;
  loading: boolean;
  error: string | null;

  fetchNews: (lang: "id" | "en", page?: number) => Promise<void>;
  fetchNewsDetail: (lang: "id" | "en", slug: string) => Promise<void>;
}

export const useNewsStore = create<NewsState>((set) => ({
  items: [],
  detail: null,
  currentPage: 1,
  totalPages: 1,
  loading: false,
  error: null,

  // =======================
  // LIST NEWS
  // =======================
  fetchNews: async (lang, page = 1) => {
    try {
      set({ loading: true, error: null });

      const res = await getNewsApi(lang, page);

      // ✅ SESUAI RESPONSE API
      const articles = res.articles;

      const mapped: NewsItem[] = articles.data.map((item: any) => ({
        id: item.id ?? item.slug,
        title: item.title,
        slug: item.slug,
        image: item.image,
        category: item.category_name,
        contentHtml: item.content,
        date: item.published_at
          ? new Date(item.published_at).toLocaleDateString(
              lang === "id" ? "id-ID" : "en-US",
              { year: "numeric", month: "long", day: "numeric" }
            )
          : "",
        tags: item.tags?.map((t: any) => t.name) || [],
      }));

      set({
        items: mapped,
        currentPage: articles.current_page,
        totalPages: articles.last_page,
      });
    } catch (err) {
      console.error("fetchNews error:", err);
      set({ error: "Failed to fetch news" });
    } finally {
      set({ loading: false });
    }
  },

  // =======================
  // DETAIL NEWS
  // =======================
  fetchNewsDetail: async (lang, slug) => {
    try {
      set({ loading: true, error: null, detail: null });

      const res = await getNewsDetailApi(lang, slug);

      // ⬇️ SESUAIKAN DENGAN RESPONSE API
      const item = res.article ?? res.data;

      const mapped: NewsItem = {
        id: item.id ?? item.slug,
        title: item.title,
        slug: item.slug,
        image: item.image,
        category: item.category_name,
        contentHtml: item.content,
        date: item.published_at
          ? new Date(item.published_at).toLocaleDateString(
              lang === "id" ? "id-ID" : "en-US",
              { year: "numeric", month: "long", day: "numeric" }
            )
          : "",
        tags: item.tags?.map((t: any) => t.name) || [],
      };

      set({ detail: mapped });
    } catch (err) {
      console.error("fetchNewsDetail error:", err);
      set({ error: "Failed to fetch news detail" });
    } finally {
      set({ loading: false });
    }
  },
}));
